import { Button } from "@remo-co/ui-core/src/components/Button";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { ComponentPropsWithRef, ReactNode } from "react";
import { useStyles } from "../../styles";

type ButtonProps = Omit<ComponentPropsWithRef<typeof Button>, "onError">;

interface Props extends ButtonProps {
  icon: ReactNode;

  label: string;
}

export const MenuButton = ({ icon: Icon, label, ...rest }: Props) => {
  const styles = useStyles();
  return (
    <Button
      {...rest}
      className={styles.button}
      variant="secondary"
      color="dark"
      size="xs"
      data-testid={`menu-button-${label}`}
      contentClassName={styles.buttonContent}
    >
      {Icon}
      <Typography variant="caption">{label}</Typography>
    </Button>
  );
};
